export const requestForm = {
  breadcrumb: {
    home: 'Home',
    requestStudy: 'Request Technical Study',
  },
  hero: {
    title: 'Submit Your Technical Request',
    subtitle: 'Complete the form below to receive a comprehensive technical analysis and customized filtration solution proposal',
    confidential: 'Confidential',
    expertReview: 'Expert Review',
    response48h: '48h Response',
  },
  progress: {
    completion: 'Form Completion',
  },
  sections: {
    companyInfo: {
      title: 'Company Information',
      companyName: 'Company Name',
      companyNamePlaceholder: 'Enter your company name',
      businessSector: 'Business Sector',
      selectSector: 'Select sector',
      sectorFoodBeverage: 'Food & Beverage',
      sectorPharmaceutical: 'Pharmaceutical & Chemical',
      sectorWaterTreatment: 'Water Treatment',
      sectorMining: 'Mining & Metallurgy',
      sectorOilGas: 'Oil & Gas',
      sectorOther: 'Other',
      country: 'Country',
      countryPlaceholder: 'Enter country',
      address: 'Address',
      addressPlaceholder: 'Enter full address',
      website: 'Website',
      websitePlaceholder: 'https://www.example.com',
    },
    mainContact: {
      title: 'Main Contact',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter full name',
      position: 'Position',
      positionPlaceholder: 'Enter position',
      email: 'Professional Email',
      emailPlaceholder: 'email@company.com',
      phone: 'Phone Number',
      phonePlaceholder: '+1 (555) 123-4567',
    },
    technicalRequirements: {
      title: 'Technical Requirements',
      required: 'REQUIRED',
      filtrationType: 'Type of Filtration Needed',
      reverseOsmosis: 'Reverse Osmosis',
      nanofiltration: 'Nanofiltration',
      ultrafiltration: 'Ultrafiltration',
      microfiltration: 'Microfiltration',
      coarseFiltration: 'Coarse Filtration',
      other: 'Other / Not Sure',
      processDescription: 'Industrial Process Description',
      processDescriptionPlaceholder: 'Describe your industrial process, current challenges, and specific requirements...',
      objective: 'Objective',
      objectivePurification: 'Purification',
      objectiveClarification: 'Clarification',
      objectiveSeparation: 'Separation',
      objectiveOther: 'Other',
      volumeCapacity: 'Volume / Capacity',
      volumeCapacityPlaceholder: 'e.g., 1000 L/h, 50 m³/day',
      technicalConstraints: 'Technical Constraints',
      technicalConstraintsPlaceholder: 'Space limitations, temperature requirements, pressure constraints, etc.',
      estimatedBudget: 'Estimated Budget',
      budgetUnder50k: 'Under $50,000',
      budget50k100k: '$50,000 - $100,000',
      budget100k250k: '$100,000 - $250,000',
      budget250k500k: '$250,000 - $500,000',
      budgetOver500k: 'Over $500,000',
      selectRange: 'Select range',
      desiredTimeline: 'Desired Timeline',
      timelinePlaceholder: 'e.g., Q2 2025, 6 months',
    },
    documents: {
      title: 'Supporting Documents',
      dragDrop: 'Drag and drop files here or click to browse',
      acceptedFormats: 'Accepted formats: PDF, DWG, XLSX, DOCX (Max 10MB each)',
    },
    consent: {
      title: 'Consent & Submission',
      agreeTo: 'I agree to the',
      privacyPolicy: 'data privacy policy',
      andConsent: 'and consent to Ste EINA Ltd processing my information for the purpose of providing technical consultation and filtration solutions.',
      submit: 'Submit Technical Request',
      submitting: 'Submitting...',
      successTitle: 'Request Submitted Successfully!',
      successDesc: 'Our technical team will review your request and contact you within 48 hours.',
      errorTitle: 'Submission Failed',
      errorDesc: 'Please try again or contact us directly at info@einaltd.com',
      responseTime: 'Expected response time: 48 hours',
      needAssistance: 'Need immediate assistance? Call',
    },
  },
  validation: {
    required: 'Please fill in all required fields.',
    consentRequired: 'Please accept the data privacy policy to continue.',
  },
  charactersCount: '{{count}}/500 characters',
};